(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Reset other product card galleries when interacting with a new card
  let activeCard = null;

  function resetCardGallery(card) {
    const slideshow = card.querySelector('slideshow-component');
    if (slideshow && typeof slideshow.select === 'function') {
      slideshow.select(0, undefined, { animate: false });
    }
  }

  document.addEventListener('pointerdown', (e) => {
    const card = e.target.closest('product-card');
    if (!card) return;
    if (card === activeCard) return;

    // Reset the previously active card's gallery
    if (activeCard) {
      resetCardGallery(activeCard);
    }
    activeCard = card;
  }, true);

  // Also reset on touch scroll — when a card leaves the viewport
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting && entry.target === activeCard) {
          resetCardGallery(entry.target);
          activeCard = null;
        }
      });
    }, { threshold: 0.1 });

    // Observe all product cards once DOM is ready
    const observeCards = () => {
      document.querySelectorAll('product-card').forEach((card) => observer.observe(card));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeCards, { once: true });
    } else {
      observeCards();
    }
  }

  } catch(e) { console.error(e); }
})();
})();
